import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

// 配置 Markdown 解析（支持表格、代码块、链接等）
const md = new MarkdownIt({
  html: false,
  xhtmlOut: false,
  breaks: true,
  linkify: true,
  typographer: true
})

export function renderMarkdown(text = '') {
  try {
    const rawHtml = md.render(String(text || ''))
    const cleanHtml = DOMPurify.sanitize(rawHtml, {
      USE_PROFILES: { html: true },
      ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
      ALLOWED_TAGS: false // 使用默认白名单
    })
    return cleanHtml
  } catch (e) {
    return String(text || '')
  }
}

export default { renderMarkdown }